import { render, staticRenderFns } from "./auditGoods.vue?vue&type=template&id=2b1254f2&scoped=true&"
import script from "./auditGoods.vue?vue&type=script&lang=js&"
export * from "./auditGoods.vue?vue&type=script&lang=js&"
import style0 from "./auditGoods.vue?vue&type=style&index=0&id=2b1254f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1254f2",
  null
  
)

export default component.exports